import { FC, ReactNode } from 'react'
import Dropdown from '../dropdown'
import { _TriggerButton } from './components/TriggerButton'
import { composeClasses } from '../../utils/compose-classes'

export interface SelectProps {
  value?: string | number
  placeholder?: string
  className?: string
  isOpen: boolean
  children: ReactNode
  buttomSheetClassName?: string
  classNameTrigger?: string
  classNameContainer?: string
  onClose: () => void
  setIsOpen: (isOpen: boolean) => void
  isDisabled?: boolean
  customTriggerButton?: ReactNode
  isResponsive?: boolean
  strategyPosition?: 'fixed' | 'absolute'
}

export const Select: FC<SelectProps> = ({
  className,
  isOpen,
  buttomSheetClassName,
  customTriggerButton,
  isResponsive,
  classNameContainer,
  isDisabled,
  children,
  placeholder,
  setIsOpen,
  onClose,
  classNameTrigger,
  strategyPosition,
  value
}) => {
  return (
    <Dropdown
      strategyPosition={strategyPosition}
      isResponsive={isResponsive}
      positionY={5}
      onClose={onClose}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDisabled={isDisabled}
      className={className}
    >
      <Dropdown.Trigger className={composeClasses('w-full', classNameTrigger)}>
        {customTriggerButton ?? (
          <_TriggerButton
            isOpen={isOpen}
            placeholder={placeholder}
            value={value}
          />
        )}
      </Dropdown.Trigger>
      <Dropdown.Menu
        className={composeClasses(
          'flex flex-col items-center justify-start',
          classNameContainer
        )}
        buttomSheetClassName={buttomSheetClassName}
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default Select
